import { css } from '@emotion/core';
import { variables as vars, media } from '@domain-group/fe-brary';
var font = vars.font,
  colour = vars.colour;
export var confirmationContainer = /*#__PURE__*/css("padding:30px 15px;", media('>=tablet'), "{padding:0 24px;}a{text-decoration:none;}");
export var headerText = /*#__PURE__*/css("font-family:", font.headingFontFamily, ";font-size:", font.h3FontSize, ";font-weight:", font.headingFontWeight, ";color:", colour.primaryDark, ";");
export var bodyText = /*#__PURE__*/css("margin:5px 0 15px;font-family:", font.bodyFontFamily, ";font-size:", font.baseFontSize, ";color:", colour.primaryDark, ";a{color:", colour.secondary, ";font-weight:", font.headingFontWeight, ";margin-left:16px;}");
export var confirmationCard = {
  name: "ot1f9f",
  styles: "border-radius:8px;box-shadow:0 2px 8px 0 rgba(0,0,0,0.15);"
};
export var image = {
  name: "r8e7qk",
  styles: "border-radius:8px 8px 0 0;object-fit:cover;"
};
export var cardInfo = {
  name: "k008qs",
  styles: "display:flex;"
};
export var date = /*#__PURE__*/css("text-align:center;margin:15px 0 15px 15px;padding-right:15px;border-right:1px solid ", colour.neutral300, ";font-weight:", font.headingFontWeight, ";font-size:", font.h4FontSize, ";color:", colour.primaryDark, ";");
export var day = /*#__PURE__*/css("font-size:", font.smallFontSize, ";font-weight:", font.headingFontWeight, ";color:", colour.primaryDark, ";");
export var address = /*#__PURE__*/css("margin:15px;font-weight:", font.headingFontWeight, ";color:", colour.primaryDark, ";");
export var time = /*#__PURE__*/css("font-size:", font.smallFontSize, ";color:", colour.neutral500, ";font-weight:normal;");
var button = {
  name: "8875ym",
  styles: "margin-top:16px;width:100%;"
};
export var calendarButton = /*#__PURE__*/css(button, ";");
export var closeButton = /*#__PURE__*/css(button, ";");